export default "__VITE_ASSET__BGo7FBxV__"